import { RELOAD_CART_ITEMS } from '../actions/RELOAD_CART_ITEMS';
import { ADD_CART_ITEM } from '../actions/ADD_CART_ITEM';
import { DEL_CART_ITEM } from '../actions/DEL_CART_ITEM';
import { SET_CART_ITEM } from '../actions/SET_CART_ITEM';

/**
 * cartReducer is a reducer created using useReducer for the purpose of managing the cart state of the app.
 * @param {array} state The current state of the cart
 * @param {object} action The action to apply to state
 * @returns the new state after applying the action
 */

const cartReducer = (state = [], action) => {
    if (!action || !action.type) 
        return state;
    switch (action.type) {
    case RELOAD_CART_ITEMS: {
        return action.payload.items;
    }
    case ADD_CART_ITEM: {
        const curItem = state
            .filter((item) => item.inventoryLevelId === action.payload.inventoryLevelId);
        if (curItem.length) {
            const { inventoryLevelId, title, imageUrl, quantity, price, availableForSale, availableQuantity, sku, handle, lineItemId, bypassNegativeQuantity } = curItem[0];
            const curItemIdx = state
                .map((item) => item.inventoryLevelId)
                .indexOf(inventoryLevelId);
            return [
                ...state.slice(0, curItemIdx),
                {
                    inventoryLevelId,
                    title,
                    imageUrl,
                    quantity: (quantity + action.payload.quantity),
                    price,
                    availableForSale,
                    availableQuantity,
                    sku,
                    handle,
                    lineItemId,
                    bypassNegativeQuantity,
                },
                ...state.slice(curItemIdx + 1),
            ];
        } else {
            const { inventoryLevelId, title, imageUrl, quantity, price, availableForSale, availableQuantity, sku, handle, lineItemId, bypassNegativeQuantity } = action.payload;
            return [
                ...state,
                {
                    inventoryLevelId,
                    title,
                    imageUrl,
                    quantity,
                    price,
                    availableForSale,
                    availableQuantity,
                    sku,
                    handle,
                    lineItemId,
                    bypassNegativeQuantity,
                },
            ];
        }
    }
    case DEL_CART_ITEM: {
        const curItem = state
            .filter((item) => item.lineItemId === action.payload.lineItemId);
        if (!curItem.length) 
            return state;
        return state
            .filter((item) => item.lineItemId !== action.payload.lineItemId);
    }
    case SET_CART_ITEM: {
        const curItem = state
            .filter((item) => item.inventoryLevelId === action.payload.inventoryLevelId);
        if (!curItem.length
                || action.payload.quantity <= 0) 
            return state;
        const { inventoryLevelId, title, imageUrl, quantity: _quantity, price, availableForSale, availableQuantity, sku, handle, lineItemId, bypassNegativeQuantity } = curItem[0];
        const curItemIdx = state
            .map((item) => item.inventoryLevelId)
            .indexOf(inventoryLevelId);
        return [
            ...state.slice(0, curItemIdx),
            {
                inventoryLevelId,
                title,
                imageUrl,
                quantity: action.payload.quantity,
                price,
                availableForSale,
                availableQuantity,
                sku,
                handle,
                lineItemId,
                bypassNegativeQuantity,
            },
            ...state.slice(curItemIdx + 1),
        ];
    }
    }
    return state;
};

export default cartReducer;